// Grid clustering untuk kapal dan landmark

export function clusterByGrid(items, cellSize, getLatLng) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const size = Number(cellSize);
  if (!(size > 0)) return [];

  const sel = new Map();
  items.forEach((item) => {
    const pos = getLatLng(item) || [];
    const lat = Number(pos[0]);
    const lng = Number(pos[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    const key = `${Math.floor(lat / size)}:${Math.floor(lng / size)}`;
    if (!sel.has(key)) sel.set(key, { sumLat: 0, sumLng: 0, items: [] });
    const content = sel.get(key);
    content.sumLat += lat;
    content.sumLng += lng;
    content.items.push(item);
  });

  const result = [];
  sel.forEach((content) => {
    result.push({
      lat: content.sumLat / content.items.length,
      lng: content.sumLng / content.items.length,
      items: content.items,
    });
  });
  return result;
}

// Makin jauh zoom out, makin besar sel biar pin gak numpuk.
export function getClusterCellSize(zoom) {
  if (zoom <= 3) return 6;
  if (zoom <= 5) return 3;
  if (zoom <= 7) return 1.5;
  return 1;
}
